import { authedEndpoint } from "~/lib/api/builder";
import { Workflows } from "~/lib/api/schemas/basic-settings";

export const list = authedEndpoint.query(
    () => ({
        url: "settings/workflow-types",
    }),
    {
        output: Workflows,
    },
);
